import React, {Component} from 'react'
import {truncateString} from '@ultradent/utilities/Strings';
import Icon from '../Icon';

const ToggleButton = ( {isTruncated, onToggle} ) => {
    return (
        <div className="mt-4">
            <span className="flex link-2 text-sm" onClick={onToggle}>
                Show {isTruncated ? 'more' : 'less'}
                <Icon name={isTruncated ? 'menu-arrow-down' : 'menu-arrow-up'} className="ml-1 text-lg"/>
            </span>
        </div>
    );
};

class TruncateText extends Component {
    state = {
        isTruncated: true,
        isToggleable: false
    };

    static defaultProps = {
        maxCharacters: 100,
        maxLines: 3
    };

    constructor ( props ) {
        super( props );
        this.toggleContent = this.toggleContent.bind( this );
    }

    componentWillMount () {
        this.setTruncatedState( this.props );
    }

    componentWillReceiveProps ( nextProps, nextContext ) {
        if ( this.props.children !== nextProps.children ) {
            this.setTruncatedState( nextProps );
        }
    }

    setTruncatedState ( {children, maxCharacters, maxLines} ) {
        if ( children.length > 1 ) {
            console.warn(
                '<TruncateText> received more than one child but expects only a single string of text. This may produce unexpected results' );
        }
        const text = children;
        const truncatedText = truncateString( text, maxCharacters, maxLines );
        const isToggleable = truncatedText !== text;

        this.setState( {
            isToggleable: isToggleable,
            isTruncated: isToggleable,
            truncatedContent: `${truncatedText}...`
        } );
    }

    toggleContent () {
        this.setState( {isTruncated: !this.state.isTruncated} );
    }

    renderContent () {
        if ( this.state.isTruncated ) {
            return this.state.truncatedContent;
        }

        return this.props.children;
    }

    render () {
        const {isTruncated} = this.state;
        return (
            <div className={this.props.className}>
                {this.renderContent()}
                {this.state.isToggleable ?
                    <ToggleButton isTruncated={isTruncated} onToggle={this.toggleContent}/>
                    : null
                }
            </div>
        );
    }
}

export default TruncateText;
